<template>
  <v-list-item
    class="list-item"
    data-testid="list-item"
    :key="account.id"
    @click="$emit('click', account)"
  >
    <v-list-item-avatar class="d-flex justify-center ma-0">
      <UserAvatar size="24px" fontSize="10px" :account="account" />
    </v-list-item-avatar>

    <v-list-item-content class="pt-1 pb-1">
      <div class="d-flex align-center justify-space-between overflow-hidden">
        <div class="flex-grow-0 flex-shrink-1 overflow-hidden">
          <v-list-item-title class="font-size-13 name">
            <text-highlight
              highlightClass="yellow lighten-1"
              data-private
              highlightComponent="span"
              :queries="searchTerm || ''"
            >
              {{ accountTitle }}
            </text-highlight>
            <span v-if="account.id === accountId" class="blue-grey--text">
              ({{ $t('common.me') }})
            </span>
          </v-list-item-title>
          <p class="ma-0 font-size-10 blue-grey--text position">
            {{ account.position }}
          </p>
        </div>

        <v-icon
          v-if="selected"
          class="flex-grow-0 flex-shrink-0 ml-1"
          color="blue"
          size="20"
          >mdi-check-circle</v-icon
        >
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex'
import UserAvatar from '@/components/UserAvatar.vue'
import userMixin from '@/mixins/userMixin.vue'

export default {
  name: 'AccountListItem',

  mixins: [userMixin],

  components: {
    UserAvatar,
  },

  props: {
    account: Object,
    searchTerm: String,
    selected: Boolean,
  },

  computed: {
    ...mapGetters(['accountId']),
    accountTitle() {
      return `${this.account.title ?? this.getFullName(this.account)} `
    },
  },
}
</script>

<style scoped lang="scss">
.name {
  line-height: 20px !important;
}

.position {
  line-height: 16px !important;
}

.list-item.v-list-item::before,
.list-item.v-list-item:hover {
  border-radius: 4px !important;
  background-color: $color-blue-grey-lighten3;
}
</style>
